export const createTestHook = (testHook: string) => {
    const DATA_TEST_HOOK_KEY_LEGACY = 'data-testhook';
    const DATA_TEST_HOOK_KEY = 'data-testid';

    if (typeof testHook !== 'string') {
        return null;
    }
    return {
        [DATA_TEST_HOOK_KEY_LEGACY]: testHook,
        [DATA_TEST_HOOK_KEY]: testHook,
    };
};
